import ChatContainer from "../components/chat/ChatContainer"

const Inbox = () => {
    return (
        <ChatContainer/>
    )
}

export default Inbox